import * as React from "react";
import classnames from "classnames";
import { BaseModal } from "../../../atoms/base-modal";

interface DownloadMatrixCodeModalProps {
  isActive: boolean;
  href: string;
  onDownloadMatrixCode: () => void;
  onModal: () => void;
}

export const DownloadMatrixCodeModal: React.FC<
  DownloadMatrixCodeModalProps
> = ({ isActive, href, onDownloadMatrixCode, onModal }) => {
  const onClose = () => {
    onModal();
  };
  return (
    <BaseModal isActive={isActive} title="ダウンロード前確認" onClose={onClose}>
      <section className="modal-card-body">
        <div className="notification is-warning is-light">
          <div>
            <span className={`icon has-text-warning`}>
              <i className={`fas fa-exclamation-triangle`} />
            </span>
            <strong>以下の注意事項を確認の上でダウンロードしてください</strong>
          </div>
          <div className="is-size-7 ml-5 mt-1">
            <ol>
              <li>
                <a href={href} target="_blank" rel="noopener noreferrer">
                  二次元コードから遷移するページ
                  <span className="icon">
                    <i className="fas fa-external-link-alt"></i>
                  </span>
                </a>
                が正しいことを確認してください。
              </li>
              <li>
                遷移先のページやURLに機微情報（個人情報など）が含まれていないことを確認してください。
              </li>
              <li>
                ダウンロードした二次元コードは読み取り確認をしてからご利用ください。
              </li>
            </ol>
          </div>
        </div>
      </section>
      <footer className="modal-card-foot">
        <button
          className="button is-failure is-fullwidth"
          onClick={() => {
            onModal();
          }}
        >
          キャンセル
        </button>
        <button
          className={classnames("button is-info is-fullwidth")}
          onClick={async (e) => {
            e.preventDefault();
            onDownloadMatrixCode();
            onModal();
          }}
        >
          ダウンロード
        </button>
      </footer>
    </BaseModal>
  );
};
